<template>
<span v-if="show">
    <slot/>
</span>
</template>

<script>
export default {
    props: {
        equalsTo: {
            type: String,
            _descr: 'content to show in case of equality with given value or values. For values - divide by ","',
        },
        lessThan: {
            type: String,
            _descr: 'content to show in case of less than given value',
        },
        moreThan: {
            type: String,
            _descr: 'content to show in case of more than given value',
        },
        equalOrLessThan: {
            type: String,
            _descr: 'content to show in case of less or equal than given value',
        },
        equalOrMoreThan: {
            type: String,
            _descr: 'content to show in case of more or equal than given value',
        },
        pending: {
            type: String,
            _descr: 'content to show in case of pending value',
        },
        notCalculable: {
            type: String,
            _descr: 'content to show in case of not calculable value',
        },
    },
    computed: {
        eValue () {
            return this.$parent.value;
        },
        eEqualsTo () {
            return this.equalsTo ? this.equalsTo.split(',').map(value => parseFloat(value)) : null;
        },
        eLessThan () {
            return this.lessThan ? parseFloat(this.lessThan) : null;
        },
        eMoreThan () {
            return this.moreThan ? parseFloat(this.moreThan) : null;
        },
        eEqualOrLessThan () {
            return this.equalOrLessThan ? parseFloat(this.equalOrLessThan) : null;
        },
        eEqualOrMoreThan () {
            return this.equalOrMoreThan ? parseFloat(this.equalOrMoreThan) : null;
        },
        ePending () {
            return this.pending !== undefined;
        },
        eNotCalculable () {
            return this.notCalculable !== undefined;
        },
        show () {
            if ((this.eValue === undefined && this.ePending === true) ||
                (this.eValue === null && this.eNotCalculable === true)
            ) {
                return true;
            }

            if (this.eValue === undefined ||
                this.eValue === null ||
                this.ePending === true ||
                this.eNotCalculable === true
            ) {
                return false;
            }

            if (this.eEqualsTo !== null) {
                return this.eEqualsTo.includes(this.eValue);
            }

            if ((this.eLessThan === null || this.eLessThan > this.eValue) &&
                (this.eMoreThan === null || this.eMoreThan < this.eValue) &&
                (this.eEqualOrLessThan === null || this.eEqualOrLessThan >= this.eValue) &&
                (this.eEqualOrMoreThan === null || this.eEqualOrMoreThan <= this.eValue)
            ) {
                return true;
            }

            return false;
        },
    },
};
</script>
